import { useSyncExternalStore } from 'react';

/**
 * Estado de la puerta RGPD compartido con el resto de la app. El tutorial y
 * los avisos contextuales no deben arrancar (ni pintarse por encima) mientras
 * queden documentos legales pendientes de aceptación.
 *
 * La verdad la guarda ConsentGateManager, que es quien consulta el servidor;
 * aquí solo se replica su decisión para quien la necesite fuera del portal.
 */

interface ConsentSnapshot {
  /** true mientras el ConsentGate está visible o su estado aún no se ha resuelto. */
  blocking: boolean;
}

let snapshot: ConsentSnapshot = { blocking: false };
const listeners = new Set<() => void>();

function emit(next: ConsentSnapshot): void {
  snapshot = next;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): ConsentSnapshot {
  return snapshot;
}

/** Consigna desde ConsentGateManager si la puerta bloquea o no la aplicación. */
export function setConsentBlocking(blocking: boolean): void {
  if (snapshot.blocking === blocking) return;
  emit({ blocking });
}

/** Suscripción React al estado de la puerta RGPD. */
export function useConsentState(): ConsentSnapshot {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
